import { debtQueryKeys as e } from "./useDebtQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { paymentsApi as n } from "@maat/api-payments";
//#region src/debt/useDebtSummaryQuery.ts
var r = (r, i) => t({
	queryKey: e.summary(r),
	queryFn: () => n.getDebtSummary(),
	enabled: !!r && (i?.enabled ?? !0),
	refetchInterval: i?.refetchInterval
});
//#endregion
export { r as useDebtSummaryQuery };
